/**
 * Central app configuration.
 *
 * API_BASE_URL — base origin for all server-hosted assets (logos, images, etc.).
 * Override at build time via SERVER_BASE_URL env var.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://smart-form.org/api';

